export default "__VITE_ASSET__Dgt73FSq__"